import { jsx as a, jsxs as i } from "react/jsx-runtime";
import * as d from "react";
import * as r from "@radix-ui/react-tooltip";
import { cn as s } from "../../../lib/utils.js";
const p = r.Provider, f = r.Root, x = r.Trigger, c = d.forwardRef(({ className: t, sideOffset: e = 6, ...o }, l) => a(r.Portal, { children: i(r.Content, { ref: l, sideOffset: e, collisionPadding: 8, className: s("z-50 max-w-[calc(100vw-1rem)] sm:max-w-xs rounded-md border border-lpr-charcoal/20 bg-lpr-charcoal text-white px-2.5 py-1.5 text-xs shadow-lg backdrop-blur-sm animate-fadeIn data-[state=closed]:animate-fadeOut dark:border-lpr-teal/50 dark:bg-lpr-teal/95 dark:text-[var(--text-primary)]", t), ...o, children: [o.children, a(r.Arrow, { className: "fill-lpr-charcoal dark:fill-lpr-teal/95" })] }) }));
c.displayName = r.Content.displayName;
export {
  f as Tooltip,
  c as TooltipContent,
  p as TooltipProvider,
  x as TooltipTrigger
};
//# sourceMappingURL=Tooltip.js.map
